<template>
  <div class="sidebar d-md-flex justify-content-md-center">
    <nav class="nav flex-column pt-md-4 sidebar-panel">
      <ul class="list-unstyled px-0 mx-0">
        <menu-item-primary v-for="(route, index) in routes" :key="index" :route="route" />
        <template v-if="isMobile">
          <hr>
          <feedback />
          <hr>
        </template>
      </ul>
      <b-nav-item
        :link-classes="'nav-link w-100 pb-3 pb-md-4 pr-4'"
        class="d-flex text-center w-100 font-weight-bold bg-white logout"
        @click="logOut"
      >
        <hr class="w-75">
        <span class="d-flex align-items-center w-100 justify-content-center">
          <font-awesome-icon class="mr-2" :icon="'sign-out-alt'" /> Logout
        </span>
      </b-nav-item>
    </nav>
  </div>
</template>

<script>
import MenuItemPrimary from "./MenuItemPrimary";
import Feedback from "@/components/header/Feedback";
import userDevice from "@/imports/mixins/userDevice";

export default {
  name: "SideBarMenu",
  components: {MenuItemPrimary, Feedback},
  mixins:[userDevice],
  computed: {
    routes: function () {
      return this.$router.options.routes.filter(route => !route.meta.parent);
    }
  },
  methods: {
    logOut: function() {
      this.$store.dispatch('logOut');
    }
  }
}
</script>

<style scoped lang="scss">

.sidebar-panel {
  box-shadow: $box-shadow;
  position: relative;
  li {
    width: 100%;
  }
}

.logout {
  bottom: 0;
  @include media-breakpoint-down(sm) {
    position: fixed;
  }
  @include media-breakpoint-up(md) {
    position: absolute;
  }
}

.nav {
  .svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1.125rem;
    width: 1.125rem;
    overflow: visible;
    vertical-align: 0;
  }
}

@include media-breakpoint-up(lg) {
  .sidebar {
    position: sticky;
    &-panel {
      border: 1px solid $border-color-nav;
    }
  }
}

@include media-breakpoint-down(lg) {
  .sidebar {
    position: fixed;
    width: 230px;
    float: left;
    top: 71px;
    z-index: 11;
    left: 0;

    &-panel {
      border-radius: 0;
      box-shadow: $box-shadow-secondary;
    }
  }
}

@include media-breakpoint-between(md, lg) {
  .sidebar {
    height: calc(100% - 60px);
  }
}

@include media-breakpoint-between(md, xl) {
  .dynamic-container {
    .sidebar {
      position: fixed !important;
      width: 230px;
      float: left;
      top: 71px;
      height: calc(100% - 60px);
      z-index: 11;
      left: 0;

      &-panel {
        border-radius: 0;
        box-shadow: $box-shadow-secondary;
      }
    }
  }
}

@include media-breakpoint-down(sm) {
  .sidebar {
    position: absolute;
    top: 61px;
    width: 80%;
    max-width: 420px;
    max-height: calc(100vh - 60px);
    min-height: 100vh;
    overflow: hidden;

    &-panel {
      height: 100vh;
      ul {
        height: 85%;
        overflow-y: auto;
      }
    }

    .logout {
      @media only screen and (max-width: 529px) {
        max-width: 79%;
      }

      @media only screen and (min-width: 530px) {
        max-width: 415px;
      }

      margin-right: 20%;
    }
  }
}
</style>
